// extracted by mini-css-extract-plugin
export default {"backdrop":"backdrop_backdrop__0rk58"};